module.exports = __webpack_public_path__ + "img/shyb.e8770766.jpg";